import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { UserPlus, Check } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MembershipPage = () => {
  return (
    <div className="min-h-screen" data-testid="membership-page">
      {/* Full page background image */}
      <div 
        className="fixed inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_fcd88aad-c020-4690-8915-1928b4488717/artifacts/3m4xkmjb_IMG_4046.png')`,
        }}
      />
      {/* Very subtle overlay for readability */}
      <div className="fixed inset-0 bg-black/30" />
      
      {/* Content */}
      <div className="relative z-10 min-h-screen pt-24 pb-12 px-6 sm:px-12">
        <div className="max-w-4xl mx-auto">
          {/* Hero Text - higher up */}
          <div className="mb-8">
            <h1 className="text-5xl sm:text-6xl font-['Oswald'] font-bold text-white drop-shadow-lg mb-3">
              BLIV MEDLEM
            </h1>
            <p className="text-xl sm:text-2xl text-gray-200 drop-shadow-lg max-w-xl">
              Bliv en del af The Others fællesskabet
            </p>
          </div>

          {/* Transparent card */}
          <div className="backdrop-blur-md bg-black/40 rounded-xl p-8 mb-8 border border-white/10">
            <h2 className="text-2xl font-['Oswald'] font-bold text-white mb-4 drop-shadow">
              At blive medlem af The Others er ikke noget man bare bliver
            </h2>
            <p className="text-gray-200 text-lg leading-relaxed mb-6 drop-shadow">
              The Others er et fællesskab med værdier. For at blive medlem skal du opfylde følgende:
            </p>
            
            <div className="space-y-6">
              <div className="border-l-4 border-blue-500 pl-6">
                <h3 className="text-xl font-['Oswald'] font-bold text-white mb-2 drop-shadow">
                  Hjælp andre
                </h3>
                <p className="text-gray-300 drop-shadow">
                  Du skal kunne lide at hjælpe andre og gøre en forskel for dem, 
                  som ikke har det så nemt i samfundet.
                </p>
              </div>
              
              <div className="border-l-4 border-blue-500 pl-6">
                <h3 className="text-xl font-['Oswald'] font-bold text-white mb-2 drop-shadow">
                  Motorcykelkørekort
                </h3>
                <p className="text-gray-300 drop-shadow">
                  Du skal have et gyldigt kørekort til motorcykel.
                </p>
              </div>
              
              <div className="border-l-4 border-blue-500 pl-6">
                <h3 className="text-xl font-['Oswald'] font-bold text-white mb-2 drop-shadow">
                  Egen motorcykel
                </h3>
                <p className="text-gray-300 drop-shadow">
                  Du skal have din egen motorcykel.
                </p>
              </div>
            </div>
          </div>
          
          {/* Transparent card */}
          <div className="backdrop-blur-md bg-black/40 rounded-xl p-8 text-center border border-white/10">
            <h3 className="text-xl font-['Oswald'] font-bold text-white mb-4 drop-shadow">
              Interesseret?
            </h3>
            <p className="text-gray-300 mb-6 drop-shadow">
              Kom med på nogle af vores ture først, så vi kan lære hinanden at kende.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/kalender" className="radial-btn px-8 py-4 rounded-xl text-center">
                Se Kalender
              </Link>
              <Link to="/kontakt-os" className="radial-btn px-8 py-4 rounded-xl text-center">
                Kontakt Os
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default MembershipPage;
